import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../redux/store/auth/auth-slice";
import {useNavigate} from "react-router-dom"

const ProfileLeft = () => {

  const {userprofiledata} = useSelector((state)=>state.auth)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  console.log(userprofiledata)

  const setProfileData = (data)=>{
    dispatch(authActions.adduserprofiledata(data))
  }

  const Logiut = ()=>{
    navigate("/")
  }


  return (
    <div className=''>
        <div className='flex flex-col gap-4 items-start text-[24px]'>
            <button onClick={()=>setProfileData("profile")} className={`${userprofiledata === "profile" ? " font-bold" : ""}`}>Perfil</button>
            <button onClick={()=>setProfileData("Información")} className={`${userprofiledata === "Información" ? " font-bold" : ""}`}>Información General</button>
            <button onClick={()=>setProfileData("Mi")} className={`${userprofiledata === "Mi" ? " font-bold" : ""}`}>Mi Plan</button>
            <button onClick={()=>setProfileData("Aviso")} className={`${userprofiledata === "Aviso" ? " font-bold" : ""}`}>Aviso de Privacidad</button>
            <button onClick={()=>Logiut()}>Cerrar sesión</button>
        </div>
    </div>
  )
}

export default ProfileLeft